import moment from 'moment';

import {
  HISCON_SET_HISTORICO_FAIL,
  HISCON_SET_HISTORICO_PORTAL_ESTADUAL_FAIL,
  HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS,
  HISCON_SET_HISTORICO_SUCCESS,
} from './types';
import box from '../api/box';
import { getUrlPortal } from '../utils/Functions';
import { sendErroRequest } from '../utils/Notification';

const urlBase = '/v1/historicos-consulta';

const setHistoricoFail = () => ({
  type: HISCON_SET_HISTORICO_FAIL,
});

const setHistoricoPortalEstadualFail = () => ({
  type: HISCON_SET_HISTORICO_PORTAL_ESTADUAL_FAIL,
});

export const setHistoricoSuccess = values => ({
  type: HISCON_SET_HISTORICO_SUCCESS,
  payload: values,
});

export const setHistoricoPortalEstadualSuccess = values => ({
  type: HISCON_SET_HISTORICO_PORTAL_ESTADUAL_SUCCESS,
  payload: values,
});

export const getHistorico = (filtroForm, cb) => async dispatch => {
  try {
    const { initialDate, finalDate, documentType, queryType } = filtroForm;

    const filtroArray = [];

    if (initialDate)
      filtroArray.push({
        campo: 'dataHoraConsulta',
        valor: moment(initialDate)
          .startOf('day')
          .format('YYYYMMDDHHmm'),
        condicao: 'gte',
      });

    if (finalDate)
      filtroArray.push({
        campo: 'dataHoraConsulta',
        valor: moment(finalDate)
          .endOf('day')
          .format('YYYYMMDDHHmm'),
        condicao: 'lte',
      });

    if (documentType) filtroArray.push({ campo: 'tipoDocumentoConsulta', valor: documentType });

    if (queryType) filtroArray.push({ campo: 'tipoConsulta', valor: queryType });

    const params = {
      ...(filtroArray.length > 0 && { filtro: JSON.stringify(filtroArray) }),
    };

    const { data } = await box.get(urlBase, { params });

    dispatch(setHistoricoSuccess(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar o histórico');

    dispatch(setHistoricoFail());
  }
};

export const getHistoricoPortalEstadual = (filtroForm, cb) => async dispatch => {
  try {
    const { initialDate, finalDate, queryType, portalType } = filtroForm;

    if (portalType && portalType > 0) {
      const filtroArray = [];

      if (initialDate)
        filtroArray.push({
          campo: 'dataHoraConsulta',
          valor: moment(initialDate)
            .startOf('day')
            .format('YYYYMMDDHHmm'),
          condicao: 'gte',
        });

      if (finalDate)
        filtroArray.push({
          campo: 'dataHoraConsulta',
          valor: moment(finalDate)
            .endOf('day')
            .format('YYYYMMDDHHmm'),
          condicao: 'lte',
        });

      if (queryType) filtroArray.push({ campo: 'tipoConsulta', valor: queryType });

      const params = {
        ...(filtroArray.length > 0 && { filtro: JSON.stringify(filtroArray) }),
      };

      const url = getUrlPortal(portalType);

      const { data } = await box.get(url, { params });

      dispatch(setHistoricoPortalEstadualSuccess(data));

      if (cb && typeof cb === 'function') cb();
    } else {
      sendErroRequest(null, 'É obrigatório selecionar qual é o portal estadual.');

      dispatch(setHistoricoPortalEstadualFail());
    }
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar o histórico.');

    dispatch(setHistoricoPortalEstadualFail());
  }
};
